import { colors } from '@revenuemarket/design';

import { IconProps } from '../../types/icon';
import { Svg } from '../style';

export default function ArrowUp({
  width = 18,
  height = 18,
  fill = colors.grayscaleBlack,
  ...props
}: IconProps) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.99989 7.84075L5.94514 10.8957C5.84126 10.9994 5.7107 11.0526 5.55345 11.0551C5.39632 11.0574 5.26339 11.0043 5.15464 10.8957C5.04601 10.7869 4.9917 10.6552 4.9917 10.5004C4.9917 10.3457 5.04601 10.2139 5.15464 10.1052L8.52532 6.7345C8.66095 6.599 8.81914 6.53125 8.99989 6.53125C9.18064 6.53125 9.33882 6.599 9.47445 6.7345L12.8451 10.1052C12.9489 10.2091 13.002 10.3396 13.0045 10.4969C13.0069 10.654 12.9538 10.7869 12.8451 10.8957C12.7364 11.0043 12.6046 11.0586 12.4499 11.0586C12.2951 11.0586 12.1634 11.0043 12.0546 10.8957L8.99989 7.84075Z"
        fill={fill}
      />
    </Svg>
  );
}
